import { postAuthCertCallback } from "apis/auth";
import { getUserInfo } from "utils/utility";

const SignupPassLoader = async () => {
  try {
    const tokenVersionId = new URL(window.location.href).searchParams.get(
      "token_version_id"
    );
    const encodedData = new URL(window.location.href).searchParams.get(
      "enc_data"
    );
    const integrityValue = new URL(window.location.href).searchParams.get(
      "integrity_value"
    );

    if (!tokenVersionId || !encodedData || !integrityValue) throw new Error();

    const email = localStorage.getItem("email") || getUserInfo()?.email;
    if (!email) return;

    const res = await postAuthCertCallback({
      email: email || "",
      tokenVersionId,
      encodedData,
      integrityValue,
    });

    if (res) {
      window.opener.postMessage({ type: "child", res }, window.location.origin);
      window.close();
      return;
    }

    throw new Error();
  } catch (e) {
    alert("문제가 발생했습니다. 다시 시도해주세요.");
    window.close();
    return;
  }
};

export default SignupPassLoader;
